var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-warn"}},[(_vm.show)?_c('div',{staticClass:"flex"},[_c('span',{staticClass:"warn"},[_vm._v(" "+_vm._s(_vm.msg)+" ")]),_vm._v(" "),_c('span',{staticClass:"close",on:{"click":_vm.closeWarn}},[_vm._v(" × ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dea2b270","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/components/Warn.vue
// module id = null
// module chunks = 